/**
 * Route copy for `src/routes/admin` (keys: `routes.admin.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  adminManualTopup: {
    creditedParsedCreditsVToTenantid: 'Credited {{parsed}} credits ({{v}}) to {{tenantId}}.',
    credit: 'Credit ',
    credits: ' credits',
  },
  communitiesCommunitiesDefaultsPage: {
    actionReservedForPlatformOperators: 'Action reserved for platform operators.',
    theAcknowledgementsAreRequiredBeforeEnab: 'The acknowledgements are required before enabling an automatic default.',
    errorStatus: 'Error {{status}}',
    theOperationFailedTryAgain: 'The operation failed. Try again.',
  },
  fleetAdminPage: {
    unlimited: 'Unlimited',
    reserved: 'reserved',
  },
  planCatalogTools: {
    planPerMonth: 'plan/month',
    pack: 'pack',
    month: 'month',
    couldNotLoadThePlans: 'Could not load the plans.',
    capsFeaturesAndCatalog: 'Caps, features and catalog',
    detailedConfigurationOfEachPlanDescripti: 'Detailed configuration of each plan (description, JSON caps, feature flags), plan creation / deactivation and publishing of the billable catalog to Stripe.',
    close: 'Close',
    configure: 'Configure',
    couldNotLoadTheStripeCatalog: 'Could not load the Stripe catalog.',
    catalogPublishedToStripeCCreated: 'Catalog published to Stripe — {{c}} created, {{u}} updated, {{n}} unchanged.',
    couldNotPublishToStripe: 'Could not publish to Stripe.',
    stripeCatalogBillable: 'Stripe catalog (billable)',
    live: 'Live',
    sandboxTest: 'Sandbox (test)',
    publishThePaidPlansAndCredit: 'Publish the paid plans and credit packs to Stripe (products + prices). After publishing, checkout references the real Stripe price. Re-run after a price change.',
    stripeIsNotConfiguredInThis: 'Stripe is not configured in this environment — publishing unavailable.',
    sku: 'SKU',
    amount: 'Amount',
    status: 'Status',
    stripePrice: 'Stripe price',
    changedRepublish: 'Changed — republish',
    published: 'Published',
    notPublished: 'Not published',
    publishing: 'Publishing…',
    publishEverythingToStripe: 'Publish everything to Stripe',
    invalidJsonCaps: 'Invalid JSON caps',
    invalidJsonFeatures: 'Invalid JSON features',
    planUpdated: 'Plan updated.',
    failed: 'Failed',
    deactivateThePlanNameCurrentUsers: 'Deactivate the plan "{{name}}"? Current users will keep their access until renewal.',
    planDeactivated: 'Plan deactivated.',
    couldNotDeactivate: 'Could not deactivate.',
    description: 'Description',
    priceMonth: 'Price/month',
    creditsMonth: 'Credits/month',
    overageCr: 'Overage/cr',
    capsJson: 'Caps (JSON)',
    featuresJsonKeyTrueFalse: 'Features (JSON — key: true/false)',
    saving: 'Saving…',
    saveThePlan: 'Save the plan',
    deactivateThisPlan: 'Deactivate this plan',
    planCreated: 'Plan created.',
    couldNotCreate: 'Could not create.',
    newPlan: 'New plan',
    code: 'Code',
    name: 'Name',
    team: 'Team',
    create: '+ Create',
  },
  plansAdminPage: {
    popular: 'Popular',
  },
  platformSettingsPage: {
    actionReservedForPlatformOperators: 'Action reserved for platform operators.',
    errorStatus: 'Error {{status}}',
    theOperationFailedTryAgain: 'The operation failed. Try again.',
  },
  privacyPrivacyCompliancePage: {
    status: 'Status',
    actions: 'Actions',
    mode: 'Mode',
  },
  vouchersAdminPage: {
    auto: 'auto',
    crRedemptionsCount: 'cr · {{redemptions_count}}',
  },
};

export default en;
